import { ProductRankingPage } from './ProductRankingPage';

export const bestProductRouter = {
  '/@/product_ranking': ProductRankingPage,
};
